import React,{useState} from "react";
import { useNavigate } from "react-router-dom";
import { get, post } from '../../util/axiosConfig/AxiosConfig';
import showAlert from "../alert/Alert";

const CombineItem = (props) => {
    const { id, type, amount, features, validity, mock, subscription } = props;
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // const manageMock = () => {
    //     localStorage.setItem('cartData', JSON.stringify(props));
    //     navigate('/CreateAccount')
    // }

    // const manageCombo = () => {
    //     localStorage.setItem('cartData', JSON.stringify(props));
    //     const userObj = JSON.parse(localStorage.getItem('userObj'))
    //     if(userObj.existingFlag == true){
    //         addtoCart(userObj.userId, id);
    //         showAlert('', 'Item added to your cart please login', 'success', 'Ok',false,false, redirectTo, false,'', '');
    //     }else{
    //         navigate('/CreateAccount')
    //     }
    // }


    const manageCombo = () => {
        localStorage.setItem('cartData', JSON.stringify(props));
        const userObj = JSON.parse(localStorage.getItem('userObj'))
        if(userObj.existingFlag == true){
            // redirectToLoginPage();
            addtoCart(userObj.userId, id, localStorage.getItem('unit'));
            showAlert('', 'Item added to your cart successfully', 'success', 'Continue Shopping',false,false, continueShopping, true,'Proceed to checkout', proceedToCheckout);
        }else{
            navigate('/CreateAccount')
        }
    }

    const continueShopping = (value) => {
        const userObj = JSON.parse(localStorage.getItem('userObj'))
        if(value === true){
            navigate('/Home?id='+userObj.userId);
        }
    }

    const proceedToCheckout = (value) => {
        if(value === true){
            redirectToLoginPage();
        }
    }

    const redirectToLoginPage = () => {
        window.open(`${process.env.REACT_APP_BENEFICIARY_BASE_URL}beneficiary-app/NewDashboard`, '_blank');
    }

    const addtoCart = async (userId, planId,unitId) => {
        let pId;
        if(localStorage.getItem('type') == 'Short') {
            pId = null;
        } else {
            pId = planId;
        }
        try {
            setLoading(true);
            const response = await get(`web/api/v1/lms-web/register/cart?userId=${userId}&planId=${pId}&unitId=${unitId}`);
        } catch (error) {
            setLoading(false);
            showAlert('', 'Selected plan already exists in your account.', 'error', 'Continue Shopping',false,false, continueShopping, true,'Proceed to checkout', proceedToCheckout);
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const redirectTo = () => {
        // window.open(`${process.env.REACT_APP_BENEFICIARY_BASE_URL}beneficiary-app`, '_blank');
    }

    return (
        <React.Fragment>
            <div className="mock_item_main">
                <div className="container">
                    <div className="subscription_box_main">
                        <div className="combine_item">
                            <div className="mock_type">
                                <p className="combo_type_text">{type}</p>
                            </div>
                            <div className="combo_amount">
                                <p className="combo_plan_one">Subscription Plan: {subscription} </p>
                                <p className="combo_plan_one">Mock Plan: {mock}</p>
                                {/* <p className="time_frame">Number of Attempts: {validity}</p> */}
                            </div>
                            <div className="mock_amount">
                                <p className="mock_amount_text">₹ {amount}</p>
                                <p className="time_frame">Validity: {validity} days</p>
                                {/* <p className="time_frame">Number of Attempts: {validity}</p> */}
                            </div>
                            <div className="combine_features">
                                <ul className="mock_features_ul">
                                    <div className="mock_features_li">
                                        {features.map((feature, index) => (
                                            <div key={index}  className="mock_features_text_main">
                                                <li className="mock_features_li">
                                                    <div className="mock_features_text_main">
                                                        <li className="subscription_features_li">
                                                            <div className="subscription_features_text_main">
                                                                <span className="tick_icon"><i class="fa-regular fa-circle-check"></i></span>
                                                                <p className="subscription_features_text">{feature}</p>
                                                            </div>
                                                           
                                                        </li>
                                                    </div>
                                                </li>
                                            </div>
                                        ))} 
                                    </div>
                                </ul>
                            </div>
                            <div className="mock_card_btn_area">
                                <button className="choosing_plan_btn" onClick={() => manageCombo()}>Choose Plan</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default CombineItem;